var map = {
	"./hints/shape1.svg": 8582,
	"./hints/shape2.svg": 90177,
	"./hints/shape3.svg": 67134,
	"./hints/shape4.svg": 70866,
	"./map.svg": 28055,
	"./shapes.svg": 79363,
	"./shapes/shape0.svg": 87389,
	"./shapes/shape1.svg": 72431,
	"./shapes/shape2.svg": 29606,
	"./shapes/shape3.svg": 53494,
	"./shapes/shape4.svg": 36429,
	"./shapes/shape5.svg": 58570,
	"./shapes/shape6.svg": 80381,
	"./shapes/shape7.svg": 84429,
	"./shapes/shape8.svg": 91942,
	"./shapes/shape9.svg": 90183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62149;